/* eslint-disable prettier/prettier */
import {
  OBTENER_DOMICILIOS_ADP_SUCCESS,
  OBTENER_DOMICILIOS_ADP_ERROR,
  SET_TRAMITE_ACCION_ADP,
  SET_TRAMITE_GUARDADO_OK,
} from '../constants/index';

const initialState = {
  domicilios: null,
  accion: null,
  selectedDomicilio: '',
};
/**
 *
 */

export default function capwebADP(state = initialState, action) {
  const newState = { ...state };
  switch (action.type) {
    case OBTENER_DOMICILIOS_ADP_SUCCESS: {
      newState.domicilios = action.domicilios;
      return newState;
    }
    case OBTENER_DOMICILIOS_ADP_ERROR: {
      newState.domicilios = [];
      return newState;
    }
    case SET_TRAMITE_ACCION_ADP: {
      newState.accion = action.accion;
      newState.selectedDomicilio = action.domicilio;
      return newState;
    }
    case SET_TRAMITE_GUARDADO_OK: {
      newState.domicilios = [];
      newState.accion = null;
      newState.selectedDomicilio = null;
      return newState;
    }
    default:
      return newState;
  }
}
